/**
 * Query params that carry sensitive, single-use tokens and must never reach
 * third-party logging/analytics. Currently the GitHub App install choice token
 * (`githubInstallState`) and its error counterpart (`githubInstallError`).
 */
const SENSITIVE_QUERY_PARAMS = ["githubInstallState", "githubInstallError"];

const REDACTED = "[redacted]";

/**
 * Redact the values of {@link SENSITIVE_QUERY_PARAMS} from a URL string while
 * leaving the rest of the URL intact. Returns the input unchanged if it can't
 * be parsed or contains none of the sensitive params (cheap fast path).
 */
export function scrubSensitiveQueryParams(url: string): string {
  if (!SENSITIVE_QUERY_PARAMS.some((param) => url.includes(param))) {
    return url;
  }
  try {
    const parsed = new URL(url, window.location.origin);
    let didChange = false;
    for (const param of SENSITIVE_QUERY_PARAMS) {
      if (parsed.searchParams.has(param)) {
        parsed.searchParams.set(param, REDACTED);
        didChange = true;
      }
    }
    if (!didChange) {
      return url;
    }
    // Preserve relative URLs (no scheme/host) as they were passed in.
    return /^[a-z]+:\/\//i.test(url)
      ? parsed.toString()
      : `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return url;
  }
}
